module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/hero-mobile_3-19a2ad9f6c39cca90e948da204d8b4a4.png";